"use client";
import SvgMollerbilSymbol from "./mollerbil_symbol.svg.js";
import SvgMollerbilWordmark from "./mollerbil_wordmark.svg.js";
const mollerbil = {
  key: "mollerbil",
  symbol: SvgMollerbilSymbol,
  wordmark: SvgMollerbilWordmark
};
export {
  mollerbil
};
